<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-accent m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                @if (action == "NEW") {
                    {{ "PROJECTS.ProjectPeriodNew" | translate }}
                }
                @if (action == "EDIT") {
                    {{ "PROJECTS.ProjectPeriodEdit" | translate }}
                }
            </span>

            <div class="header-actions">
                <button
                    mat-raised-button
                    type="button"
                    class="btn-save"
                    (click)="save()"
                    [disabled]="periodForm.invalid || !!validationMessage"
                >
                    {{ "PROJECTS.ProjectPeriodSave" | translate }}
                </button>

                <button mat-raised-button type="button" (click)="cancel()">
                    {{ "PROJECTS.CANCEL" | translate }}
                </button>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="dialog-content p-24 m-0" fusePerfectScrollbar>
        <form name="periodForm" [formGroup]="periodForm" class="period-form w-100-p" fxLayout="column" fxFlex>
            <div class="section">
                <mat-form-field appearance="outline">
                    <mat-label>{{ "PROJECTS.ProjectPeriodName" | translate }}</mat-label>
                    <input matInput name="name" formControlName="name" placeholder="{{ 'PROJECTS.ProjectPeriodName' | translate }}" />
                </mat-form-field>
            </div>

            <div class="intervals-header">
                <h3>{{ "PROJECTS.ProjectPeriodIntervals" | translate }}</h3>
                <button mat-stroked-button type="button" (click)="addInterval()">
                    {{ "PROJECTS.ProjectPeriodAddInterval" | translate }}
                </button>
            </div>

            <div formArrayName="intervals" class="interval-list">
                @for (intervalControl of intervalsFormArray.controls; track $index) {
                    <div class="interval-card" [formGroupName]="$index">
                        <div class="section section--row">
                            <mat-form-field appearance="outline">
                                <mat-label>{{ "PROJECTS.ProjectPeriodStart" | translate }}</mat-label>
                                <mat-select formControlName="startTime" (selectionChange)="onIntervalChange()">
                                    @for (interval of timeIntervals; track interval) {
                                        <mat-option [value]="interval">
                                            {{ interval }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>{{ "PROJECTS.ProjectPeriodEnd" | translate }}</mat-label>
                                <mat-select formControlName="endTime" (selectionChange)="onIntervalChange()">
                                    @for (interval of timeIntervals; track interval) {
                                        <mat-option [value]="interval">
                                            {{ interval }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            <button
                                mat-icon-button
                                type="button"
                                class="interval-remove"
                                (click)="removeInterval($index)"
                                [disabled]="intervalsFormArray.length <= 1"
                            >
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </div>
                    </div>
                }
            </div>

            @if (validationMessage) {
                <div class="validation-message">
                    {{ validationMessage }}
                </div>
            }
        </form>
    </mat-dialog-content>
</div>
